import React from 'react';
import styles from './Footer.module.css';
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin, FaYoutube, FaMapMarkerAlt, FaPhone, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div className={styles.footerRow}>
          <div className={styles.footerCol}>
            <h4 className={styles.footerTitle}>ShreeOhm</h4>
            <p className={styles.footerAbout}>
             Discover the pure essence of Karnali’s organic treasures — nature’s goodness delivered to you.
            </p>
            <div className={styles.socialLinks}>
              <a href="https://facebook.com" aria-label="Facebook"><FaFacebook className={styles.socialIcon} /></a>
              <a href="https://twitter.com" aria-label="Twitter"><FaTwitter className={styles.socialIcon} /></a>
              <a href="https://instagram.com" aria-label="Instagram"><FaInstagram className={styles.socialIcon} /></a>
              <a href="https://linkedin.com" aria-label="LinkedIn"><FaLinkedin className={styles.socialIcon} /></a>
              <a href="https://youtube.com" aria-label="YouTube"><FaYoutube className={styles.socialIcon} /></a>
            </div>
          </div>

          <div className={styles.footerCol}>
            <h4 className={styles.footerHeading}>Quick Links</h4>
            <ul className={styles.footerList}>
              <li><a href="/">Products</a></li>
              <li><a href="/ourproducts">Our Products</a></li>
              <li><a href="/supplements">Supplements</a></li>
              <li><a href="/about-us">About Us</a></li>
              <li><a href="/contact-us">Contact Us</a></li>
            </ul>
          </div>

          <div className={styles.footerCol}>
            <h4 className={styles.footerHeading}>Services</h4>
            <ul className={styles.footerList}>
              <li><a href="#">Organic Store</a></li>
              <li><a href="#">Meditation</a></li>
              <li><a href="#">Yoga Classes</a></li>
              <li><a href="#">Counseling</a></li>
              <li><a href="#">Medical Camps</a></li>
            </ul>
          </div>

          <div className={styles.footerCol}>
            <h4 className={styles.footerHeading}>Contact Us</h4>
            <ul className={styles.footerContact}>
              <li>
                <FaMapMarkerAlt className={styles.contactIcon} />
                <span>Birendranagar, Tatapani, Surkhet</span>
              </li>
              <li>
                <FaPhone className={styles.contactIcon} />
                <span>+977 9858060350</span>
              </li>
              <li>
                <FaEnvelope className={styles.contactIcon} />
                <span>shreeohm083@gmail.com</span>
              </li>
            </ul>
          </div>
        </div>

        <div className={styles.footerBottom}>
          <div className={styles.copyright}>
            &copy; {currentYear} ShreeOhm. All rights reserved. 
<br />
Contact the <a href="https://aviralpaudel.com.np/" style={{ color: "white", textDecoration: "none", fontWeight: "bold" }}>
  Developer
</a>

          </div>
          <div className={styles.footerLinks}>
            <a href="/privacy">Privacy Policy</a>
            <span className={styles.divider}>|</span>
            <a href="/terms">Terms of Service</a>
            <span className={styles.divider}>|</span>
            <a href="/sitemap">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
